/**
 * Deterministic bucketing in [0, 1). Keyed on the RudderStack anonymous ID, so
 * analysis hashes anonymous_id, not user_id. Trino must match exactly:
 *
 *   WITH FUNCTION ab_test_value(id varchar, salt varchar) RETURNS double
 *     RETURN CAST(bitwise_right_shift(from_big_endian_64(
 *       X'00' || substr(sha256(to_utf8(salt) || X'00' || to_utf8(id)), 1, 7)
 *     ), 3) AS double) / 9007199254740992.0
 */
export const abTestValue = async (
  id: string,
  salt: string,
): Promise<number> => {
  // NUL separator: without it ("a" + "bc") and ("ab" + "c") collide.
  const bytes = new TextEncoder().encode(`${salt}\0${id}`);
  const digest = await window.crypto.subtle.digest("SHA-256", bytes);
  const value53 = new DataView(digest).getBigUint64(0) >> 11n;

  return Number(value53) / 2 ** 53;
};
